import { useSuspenseQuery } from '@tanstack/react-query';
import { BaseSuspenseQueryOpts } from '../baseTypes';
import { getAppointmentReminders } from '@uplift/api';


export const useAppointmentRemindersQuery = (appointmentId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'appointment', appointmentId, 'reminders' ],
    queryFn: async () => {
      const response = await getAppointmentReminders(appointmentId);

      return response.data;
    },
    ...opts
  });
};
